import { useState, useEffect } from "react";
import { Table, Pagination, Space, Popconfirm, Spin, message } from "antd";
import { useNavigate } from "react-router-dom";
import { DeleteFilled, EditOutlined } from "@ant-design/icons";
import { get, del } from "../../../services";

const Admintable = () => {
  const [adminData, setAdmindata] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [selectedRecord, setSelectedRecord] = useState(false);
  const navigate = useNavigate();
  const limit = 20;

  // Method for API call
  const getAllAdmins = (currentPage) => {
    setLoader(true);
    get(`/seoTags?page=${currentPage}&limit=${limit}`)
      .then((response) => {
        setAdmindata(response?.data);
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  //  GET All Admins
  useEffect(() => {
    getAllAdmins(currentPage);
    // eslint-disable-next-line
  }, []);

  // confirm handler
  const confirm = (data) => {
    setSelectedRecord(data?._id);
    // API call to delete selected record
    del(`/seoTags/${data?._id}`)
      .then(() => {
        // to delete locally from our frontend lists
        const remaingRecords = adminData?.seoTags?.filter(
          (item) => item?._id !== data?._id
        );
        setAdmindata({ ...adminData, seoTags: remaingRecords });
        // success message
        message.success("Record deleted Successfully");
        setSelectedRecord(false);
      })
      .catch(() => {
        message.error("Error");
        setSelectedRecord(false);
      });
  };

  // Cancel
  const cancel = (e) => {
    console.log(e);
  };
  // Table Columns
  const columns = [
    {
      title: "#",
      dataIndex: "",
      key: "_id",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (data) => <Space size="middle">{data}</Space>,
    },
    {
      title: "Meta Title",
      dataIndex: "meta_title",
      key: "meta_title",
    },
    {
      title: "Action",
      key: "",
      render: (data) => (
        <div className="flex">
          <div className="px-4">
            {data?._id === selectedRecord ? (
              <Spin />
            ) : (
              <Popconfirm
                title="Delete the task"
                description="Are you sure to delete this task?"
                onConfirm={() => confirm(data)}
                onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <DeleteFilled className="cursor-pointer delete-icon-admin" />
              </Popconfirm>
            )}
          </div>{" "}
          <div className="px-4">
            <EditOutlined
              key="edit"
              className="delete-icon-admin cursor-pointer "
              onClick={() => navigate("/edit-seo/" + data?._id)}
            />
          </div>
        </div>
      ),
    },
  ];
  return (
    <div>
      <div className="header4">
        <h3>SEO</h3>
        <div className="header py-4">
          <button onClick={() => navigate("/add-seo")}>Add New</button>
        </div>
      </div>
      {/* table */}
      <Table
        columns={columns}
        dataSource={adminData?.seoTags}
        loading={loader}
        pagination={false}
        scroll={{ x: 1023 }}
      />
      <Pagination
        defaultPageSize={currentPage}
        showSizeChanger={false}
        current={currentPage}
        pageSize={limit}
        total={adminData?.totalSeoTags}
        onChange={(e) => {
          setCurrentPage(e);
          getAllAdmins(e);
        }}
        className="pagination"
      />
    </div>
  );
};
export default Admintable;
